import React, { useContext, useEffect } from 'react';
import { GlobalState, ScrollPosition } from '../../store';
import { Wrapper, Track, HandlePosition, Handle } from './style';

function getPosition(el) {
  var xPosition = 0;
  var yPosition = 0;

  while (el) {
    if (el.tagName == 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      var xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
      var yScrollPos = el.scrollTop || document.documentElement.scrollTop;

      xPosition += el.offsetLeft - xScrollPos + el.clientLeft;
      yPosition += el.offsetTop - yScrollPos + el.clientTop;
    } else {
      xPosition += el.offsetLeft - el.scrollLeft + el.clientLeft;
      yPosition += el.offsetTop - el.scrollTop + el.clientTop;
    }

    el = el.offsetParent;
  }
  return {
    x: xPosition,
    y: yPosition,
  };
}

const Timeline = () => {
  const { theme } = useContext(GlobalState.State);
  const { scrollProgress, handleContent } = useContext(ScrollPosition.State);

  return (
    <Wrapper>
      <Track>
        <HandlePosition
          style={{ transform: `translate3D(0, ${scrollProgress * 100}%, 0)` }}
        >
          <Handle background={theme.backgroundColor}>{handleContent}</Handle>
        </HandlePosition>
      </Track>
    </Wrapper>
  );
};

export default Timeline;
